import { adityaBirlaInsurance, digitInsurance, Insurer } from '@helpers/interfaces/insurer';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Interface of slice
interface InsurerState{
  insurers: Insurer[],
  selectedInsurer:Insurer|null
}

const initialState: InsurerState = {
    insurers : [
      adityaBirlaInsurance,
      digitInsurance
    ],
    selectedInsurer:null
}

export const InsurerSlice = createSlice({
  name: "Insurer",
  initialState,
  reducers: {
    setSelectedInsurer(state: InsurerState, action: PayloadAction<Insurer>) { 
      state.selectedInsurer = action.payload
    }
  },
});

export const {
  setSelectedInsurer
} = InsurerSlice.actions;

export default InsurerSlice.reducer;
